import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  sizing: {
    contentWidth: 1240,
  },
  palette: {
    primary: {
      main: "#3470eb",
    },
    secondary: {
      main: "#E9EFF6",
    },
    error: {
      main: "#DB000C",
    },
    warning: {
      main: "#087FFF",
      dark: "#464299",
    },
    info: {
      main: "#087FFF",
    },
  },
  overrides: {
    MuiTypography: {
      root: {
        color: "#262626",
        textAlign: "center",
        "@media (min-width:960px)": {
          textAlign: "left",
        },
      },
      h2: {
        marginBottom: "10px",
        fontWeight: "400",
        fontSize: "1.9rem",
        "@media (min-width:960px)": {
          textAlign: "left",
        },
      },
      h4: {
        marginBottom: "10px",
        fontWeight: "400",
        fontSize: "1.9rem",
        "@media (min-width:960px)": {
          fontSize: "2rem",
        },
        "@media (min-width:1280px)": {
          fontSize: "2rem",
        },
      },
      h6: {},
    },
  },
});

export default theme;
